import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdOnboardingsOptions } from '@onefootprint/fetch-dashboard';
import { Select } from '@onefootprint/ui';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useCurrentEntityOtherInsights from '@/entity/hooks/use-current-entity-other-insights';
import useEntityId from '@/entity/hooks/use-entity-id';
import OtherInsights from '../../../other-insights';
import Section from '../../../section';
import useOnboardingLabel from '../../use-onboarding-label';
const ALL_ONBOARDINGS = 'all';
const OtherInsightsSection = () => {
  const $ = _c(21);
  const {
    t
  } = useTranslation("entity-details");
  const entityId = useEntityId();
  const onboardingLabel = useOnboardingLabel();
  const {
    data: insights
  } = useCurrentEntityOtherInsights();
  let t0;
  if ($[0] !== entityId) {
    t0 = getEntitiesByFpIdOnboardingsOptions({
      path: {
        fpId: entityId
      },
      query: {
        pageSize: 100
      }
    });
    $[0] = entityId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data: onboardingsPage
  } = useQuery(t0);
  const [selectedId, setSelectedId] = useState(ALL_ONBOARDINGS);
  let T0;
  let pickedId;
  let t1;
  let t2;
  let t3;
  if ($[2] !== insights || $[3] !== onboardingLabel || $[4] !== onboardingsPage?.data || $[5] !== selectedId || $[6] !== t) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const onboardingIds = Array.from(new Set(insights?.flatMap(_temp)));
      pickedId = onboardingIds.includes(selectedId) ? selectedId : undefined;
      const getOnboardingLabel = onboardingId => {
        const onboarding = onboardingsPage?.data.find(candidate => candidate.id === onboardingId);
        return onboarding ? onboardingLabel(onboarding) : t(_temp2);
      };
      if (!insights?.length) {
        t3 = null;
        break bb0;
      }
      T0 = Section;
      if ($[12] !== t) {
        t1 = t(_temp3);
        $[12] = t;
        $[13] = t1;
      } else {
        t1 = $[13];
      }
      t2 = onboardingIds.length ? <Select aria-label={t(_temp4)} size="compact" value={pickedId ?? ALL_ONBOARDINGS} onChange={setSelectedId} options={[{
        value: ALL_ONBOARDINGS,
        label: t(_temp5)
      }, ...onboardingIds.map(onboardingId_0 => ({
        value: onboardingId_0,
        label: getOnboardingLabel(onboardingId_0)
      }))]} /> : null;
    }
    $[2] = insights;
    $[3] = onboardingLabel;
    $[4] = onboardingsPage?.data;
    $[5] = selectedId;
    $[6] = t;
    $[7] = T0;
    $[8] = pickedId;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    T0 = $[7];
    pickedId = $[8];
    t1 = $[9];
    t2 = $[10];
    t3 = $[11];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[14] !== pickedId) {
    t4 = <OtherInsights onboardingId={pickedId} />;
    $[14] = pickedId;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== T0 || $[17] !== t1 || $[18] !== t2 || $[19] !== t4) {
    t5 = <T0 title={t1} suffixActions={t2}>{t4}</T0>;
    $[16] = T0;
    $[17] = t1;
    $[18] = t2;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
};
export default OtherInsightsSection;
function _temp(insight) {
  return insight.onboardingId ? [insight.onboardingId] : [];
}
function _temp2($) {
  return $.classicOnboardings.unnamedOnboarding;
}
function _temp3($_0) {
  return $_0.otherInsights.title;
}
function _temp4($_1) {
  return $_1.classicOnboardings.onboardingFilter;
}
function _temp5($_2) {
  return $_2.classicOnboardings.allOnboardings;
}